module.exports = __webpack_public_path__ + "media/images/email/virgingopro_logo-04091f83fb9e8daad436936b9585de9e.jpg";